module.exports = __webpack_public_path__ + "img/8-load-template.18e9b32c.png";